import { Service } from "../@data";
import { firestore } from "./firebase";
import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";

export const createService = (
  service: Omit<Service, "id" | "createdAt" | "updatedAt">
) => {
  return new Promise<string>((resolve, reject) => {
    const now = Date.now();
    addDoc(collection(firestore, "services"), {
      ...service,
      createdAt: now,
      updatedAt: now,
    })
      .then((docRef) => resolve(docRef.id))
      .catch((error) => reject(error));
  });
};

export const getAllServices = (): Promise<Service[]> => {
  return new Promise((resolve, reject) => {
    getDocs(collection(firestore, "services"))
      .then((querySnapshot) => {
        resolve(
          querySnapshot.docs.map(
            (doc) => ({ id: doc.id, ...doc.data() } as unknown as Service)
          )
        );
      })
      .catch((error) => reject(error));
  });
};

export const getServiceById = (id: string): Promise<Service | null> => {
  return new Promise((resolve, reject) => {
    const docRef = doc(firestore, "services", id);
    getDoc(docRef)
      .then((docSnap) => {
        if (docSnap.exists()) {
          resolve({ id: docSnap.id, ...docSnap.data() } as unknown as Service);
        } else {
          resolve(null);
        }
      })
      .catch((error) => reject(error));
  });
};

export const updateService = (
  id: string,
  data: Partial<Omit<Service, "id" | "createdAt" | "updatedAt">>
) => {
  return new Promise<void>((resolve, reject) => {
    const docRef = doc(firestore, "services", id);
    updateDoc(docRef, { ...data, updatedAt: Date.now() })
      .then(() => resolve())
      .catch((error) => reject(error));
  });
};

export const deleteService = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    const docRef = doc(firestore, "services", id);
    deleteDoc(docRef)
      .then(() => resolve())
      .catch((error) => reject(error));
  });
};
